import { GIPIBaseAbstractFilterModel } from '@gipi-shared/models/base-abstract-filter.model';
import { GIPIUuid } from '@gipisistemas/ng-core';

export class SaleProductFilterDTO extends GIPIBaseAbstractFilterModel {

    enabled: boolean;

    productsIdsExcluded: GIPIUuid[];

}
